import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const activeChangesBlock = css`
	padding: 15px 10px 15px 0;
	overflow-y: auto;
	margin-bottom: 5px;
	width: 100%;
	text-align: right;

	flex: 1;

	.changeBlock {
		margin-bottom: 15px;
		color: ${colors.infoText};
		width: 100%;
	}

	.changeHeader {
		font-weight: 600;
		color: ${colors.mainText};

		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.headerTitle {
		font-size: 14px;

		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
	}

	.link {
		color: ${colors.mainText};
		:hover {
			cursor: pointer;
			text-decoration: underline;
		}
	}

	.changeTitle {
		font-size: 12px;
	}

	.elementPreview {
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.badge {
		margin-left: 10px;
	}
`;
